import { useParams } from "react-router-dom";
import { RunDetailsContainer } from "./container";

export const RunDetailsPane = () => {
  const params = useParams();
  const { inputId, workflowId, variablesId, runAttemptId } = params;
  if ([inputId, workflowId, variablesId, runAttemptId].includes(undefined)) {
    return null;
  }
  return (
    <RunDetailsContainer
      inputId={inputId!}
      workflowId={workflowId!}
      variablesId={variablesId!}
      runAttemptId={runAttemptId!}
    />
  );
};
